"use client";
import type { CSSProperties, ReactElement, ReactNode, RefObject } from 'react';
import { Ccontainer } from '../Ccontainer';
import { Cpolicymodal } from '../Cpolicymodal';
import { Ctermsmodal } from '../Ctermsmodal';
import { ColorType } from '@/theme/colors';
import type { AuthModalLayout } from './authModalLayout';
const EMPTY_BOX_SHADOW = 'none';
interface CauthmodalFrameProps {
    children: ReactNode;
    className?: string;
    hasOpenedPolicy: boolean;
    hasOpenedTerms: boolean;
    modalLayout: AuthModalLayout;
    onClosePolicy: () => void;
    onCloseTerms: () => void;
    showPolicy: boolean;
    showTerms: boolean;
    style?: CSSProperties;
    wrapperRef: RefObject<HTMLDivElement | null>;
}
export function CauthmodalFrame({ children, className, hasOpenedPolicy, hasOpenedTerms, modalLayout, onClosePolicy, onCloseTerms, showPolicy, showTerms, style, wrapperRef, }: CauthmodalFrameProps): ReactElement {
    return (
      <div data-el="Cauthmodal/Frame/Root" ref={wrapperRef} className={className} style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            alignSelf: 'center',
            maxWidth: modalLayout.maxWidth,
            width: '100%',
            ...style,
        }}>
        <Ccontainer padding={modalLayout.padding} width="100%" backgroundColor={ColorType.Transparent} backgroundOpacity={0} borderColor={ColorType.Transparent} borderOpacity={0} borderWidth={0} boxShadow={EMPTY_BOX_SHADOW} backdropBlur={0} innerBorder={false}>
          {children}
        </Ccontainer>
        {hasOpenedTerms && (<Ctermsmodal visible={showTerms} onClose={onCloseTerms}/>)}
        {hasOpenedPolicy && (<Cpolicymodal visible={showPolicy} onClose={onClosePolicy}/>)}
      </div>
    );
}
